<template>
   <div class="main">
      <div class="dne-entities-page">
         <div id="dne"></div>
         <Header :dataSource="PageEntity" />

         <section>
            <h1 class="title-secondary">DNE Pay</h1>
            <div class="load load-200" v-if="!showContent"></div>
            
            <div class="container lp-private-sale" v-if="showContent">
               <div class="row">
                  <div class="col-12 col-lg-6">
                     <img src="~@/assets/images/content/dne-pay.png" alt="DNE Pay">
                  </div>

                  <div class="col-12 col-lg-6">
                     <div class="box-text">
                        <h2>
                           <small>{{ getMyLanguage("entities","title.entity") }}</small>
                           DNE <span>P</span>ay
                        </h2>
                        
                        <p v-html='getMyLanguage("entities","text.dne-pay")'></p>

                        <a :href="`${VUE_APP_PAY_URL}${flagSelected}`" v-if="!$store.state.statusLogin" class="btn-primary">
                           DNE Pay
                        </a>

                        <div @click="lnkPay()" v-else class="btn-primary">
                           DNE Pay
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <!-- <section class="content-construction">
            <div class="construction">
               <h1 class="title-primary">DNE <span>P</span>ay</h1>
               <p>{{ getMyLanguage("construction", "construction.title") }}</p>
            </div>
         </section> -->
      </div>
      
      <Footer />
      <CookieConsent />
   </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import getMyContentLanguage from "@/services/contentLanguage.js";

export default {
   components: {
      Header,
      Footer,
      CookieConsent
   },

   data(){
      return {
         flagSelected: "en",

         PageEntity: "pay",
         showContent: false,

         VUE_APP_PAY_URL: process.env.VUE_APP_PAY_URL,
      }
   },

   async mounted(){
      setTimeout(() => {
         this.showContent = true
      }, 1000);
   },

   methods: {
      getMyLanguage(group, code) {
         return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code);
      },

      languageSelected(){
            this.flagSelected = this.$store.state.SelectLanguage.code
            
            if ( !this.flagSelected ){
               this.flagSelected = "en"
            }
      },

      lnkPay(){
            this.newtk = localStorage.getItem('accessToken')
            window.location.href = `${this.VUE_APP_PAY_URL}${this.flagSelected}/account/token-auth?tk=${this.newtk}&destiny=client-space`
      },
   },

   watch: {
      '$store.state.SelectLanguage.code': {
            immediate: true,
            handler() {
               this.languageSelected()
            }
      }
   },

   created() {
      // document.title = this.getMyLanguage("seo", "title.dnePay");
      document.title = "DNE Pay | DNE Token";
      document.getElementsByTagName('meta')["description"].content = this.getMyLanguage("seo", "title.description.dnePay");
   },
}
</script>

<style src="@/assets/scss/_entitiesPage.scss" lang="scss" scoped />
<style src="./custom-pay.scss" lang="scss" scoped />


<style>
   html,body,#app,.main{height: 100%;}
</style>